// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1twK-","load8":"Spinner_load8__36vjM","Small":"Spinner_Small__1zuma","LightColor":"Spinner_LightColor__MhwGi"};